import { Helmet } from 'react-helmet-async';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import axios from "axios";
import mqtt from 'mqtt';
import "./styles.css";
import LampCreate from '../pages/LampCRUDPages/create';
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  TablePagination,
  Box,
  Select,
  Grid,
  CardContent,
  CardHeader,
  TextField,
  Switch,
  FormControlLabel,
  MenuItem,
  Avatar,
  InputLabel,
  FormControl
} from '@mui/material';

import LampControl from '../components/LampControl';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

export default function LampListAll() {

  const { user: currentUser } = useSelector((state) => state.auth);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterName, setFilterName] = useState('');
  const [mqttData, setMqttData] = useState({});
  const navigate = useNavigate();
  const [showlampcreate, setShowLampCreate] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [streetlamps, setStreetlamps] = useState([])
  const [deleteLamp, setDeleteLamp] = useState(null);

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
  const MQTT_BROKER = process.env.MQTT_BROKER;

  useEffect(() => {
    const client = mqtt.connect('wss://smartlight.bhtelecom.ba:8083');

    client.on('connect', () => {
      console.log('Povezan na MQTT broker');
      client.subscribe('/smartmap/updates/#', { qos: 1 });
      client.subscribe('/smartmap/lampstatusupdates/#', { qos: 1 });

    });

    client.on('message', (topic, message) => {
      const data = JSON.parse(message.toString());
      // data = { devEUNumber, status }
      console.log('Mqtt podaci', data);

      if (topic.startsWith('/smartmap/lampstatusupdates/')) {
        // update mqttData samo za taj devEUNumber
        setMqttData(prev => ({
          ...prev,
          [data.devEUNumber]: data
        }));

        const status = data.channel.onoff ? 'active' : 'inactive';
        const bri = data.channel.bri;
        console.log('Data:', JSON.stringify(data));
        console.log('devEUNumber:', data.devEUNumber);
        console.log('Status:', status);
        console.log('BRI:', bri);

        setStreetlamps(prevLamps =>
          prevLamps.map(lamp =>
            lamp.devEUNumber === data.devEUNumber
              ? { ...lamp, status: status, currentDimming: bri }
              : lamp
          )
        );
      }

      if (topic.startsWith('/smartmap/updates/')) {
        console.log('Data:', JSON.stringify(data));
        console.log('devEUNumber:', data.devEUNumber);
        console.log('Status:', data.status);
        console.log('BRI:', data.bri);

        setStreetlamps(prevLamps =>
          prevLamps.map(lamp =>
            lamp.devEUNumber === data.devEUNumber
              ? { ...lamp, status: data.status, currentDimming: data.bri }
              : lamp
          )
        );
      }
    });

    return () => client.end();
  }, []);

  useEffect(() => {
    getAllLamps();
  }, [dataloaded]);

  useEffect(() => {
    getZones();
  }, []);

  useEffect(() => {
    getStreetlamps(selectedZone);
  }, [selectedZone]);


  const getAllLamps = async () => {
    try {
      const response = await axios.get(SERVER_URL + "/api/streetlamps");
      setStreetlamps(response.data);

      // Inicijalizuj mqttData sa default vrijednostima za sve lampe
      const initialMqttData = {};
      response.data.forEach(lamp => {
        initialMqttData[lamp.devEUNumber] = {
          devEUNumber: lamp.devEUNumber,
          channel: { onoff: false, bri: 0, elec: { voltage: 0, current: 0, actps: 0 } },
          runtime: { hours: 0 },
          sensor: { lux: 0 },
          timestamp: new Date().toISOString()
        };
      });
      setMqttData(initialMqttData);

    } catch (err) {
      console.log("error");
    }
  };

  const getZones = async () => {
    try {
      const res = await axios.get(`${SERVER_URL}/api/zonas`);
      setZones(res.data);
    } catch (err) {
      console.error("Error loading zones", err);
    }
  };

  const getStreetlamps = async (zonaid = "") => {
    try {
      const url = zonaid
        ? `${SERVER_URL}/api/streetlamps?zonaid=${zonaid}`
        : `${SERVER_URL}/api/streetlamps`;

      const res = await axios.get(url);
      setStreetlamps(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // unutar komponente LampListAll
  const handleDelete = async (lampId, lampName) => {
    if (!window.confirm(`Jeste li sigurni da želite obrisati lampu ${lampName}?`)) return;

    try {
      await axios.delete(`${SERVER_URL}/api/streetlamps/${lampId}`);
      // ukloni lampu iz state-a
      setStreetlamps(prev => prev.filter(l => l.id !== lampId));
    } catch (err) {
      console.error('Greška prilikom brisanja lampe:', err);
      alert('Došlo je do greške prilikom brisanja lampe.');
    }
  };



  const applyFilter = () => {
    if (!filterName) return streetlamps;

    return streetlamps.filter((lamp) =>
      lamp.name.toLowerCase().includes(filterName.toLowerCase())
    );
  };

  const filteredLamps = applyFilter();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const fieldStyle = {
    '& .MuiOutlinedInput-root': {
      color: '#ff9800',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ff9800'
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ffa726'
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#ff9800'
      }
    },

    '& .MuiInputLabel-root': {
      color: '#ff9800'
    },

    '& .MuiInputLabel-root.Mui-focused': {
      color: '#ff9800'
    }
  };

  return (
    <>
      <Helmet>
        <title> Pametne lampe </title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          backgroundColor: '#001536',
          height: '100%', // 🔥 umjesto 100vh
          padding: '20px',
          borderRadius: '0px'
        }}
      >
        <Typography
          sx={{
            color: '#ff9800',
            fontSize: '1.3rem',
            fontWeight: 600,
            mb: 2
          }}
        >
          Pregled lampi
        </Typography>

        <div>
          <Stack direction="row" spacing={2} alignItems="center">
            {/* Dugme Dodaj lampu */}
            <Button
              sx={{
                minWidth: 100,
                backgroundColor: '#001B44',
                color: '#ff9800',                // 🔥 tekst orange
                border: '1px solid #ff9800',     // 🔥 border orange
                '&:hover': {
                  backgroundColor: '#001B44',
                  border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                  color: '#ffa726'
                }
              }}
              onClick={() => setShowLampCreate(true)}
            >
              Dodaj lampu
            </Button>
            <Typography
              sx={{
                color: '#ff9800',
                fontSize: '1rem',
                fontWeight: 600,
                mb: 2
              }}
            >
              Odaberite zonu
            </Typography>
            {/* FILTER PO ZONI */}
            <Box sx={{ minWidth: 220 }}>
              <FormControl
                variant="outlined"
                size="small"
                sx={{
                  minWidth: 220,
                  ...fieldStyle,

                  '& .MuiOutlinedInput-root': {
                    height: 44,

                    '& fieldset': {
                      borderColor: '#ff9800',
                    },

                    '&:hover fieldset': {
                      borderColor: '#ffa726',
                    },

                    '&.Mui-focused fieldset': {
                      borderColor: '#ff9800',
                    }
                  },

                  '& .MuiSelect-select': {
                    padding: '10px 14px',
                    color: '#ff9800',
                  },

                  '& .MuiInputLabel-root': {
                    color: '#ff9800',
                  },

                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#ff9800',
                  }
                }}
              >
                {/* 🔥 label fiksirana */}
<Select
  value={selectedZone}
  onChange={(e) => setSelectedZone(e.target.value)}
  displayEmpty
  sx={{ color: '#ff9800' }}
>
  <MenuItem value="">
    <em>Sve zone</em>
  </MenuItem>

  {zones.map((zone) => (
    <MenuItem key={zone.id} value={zone.id}>
      {zone.name}
    </MenuItem>
  ))}
</Select>
              </FormControl>
            </Box>
          </Stack>

          <br />

          {showlampcreate &&
            <LampCreate
              onSuccess={() => {
                setShowLampCreate(false);
                setDataLoaded(prev => !prev);
              }}
              onCancel={() => setShowLampCreate(false)}
              className="child"
            />
          }
        </div>
        <br />

        <Stack spacing={2}>
          {filteredLamps.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((lamp) => {

              const data = mqttData[lamp.devEUNumber];
              const hasData = data?.channel?.elec?.voltage > 0;
              const isAlarm = lamp.status?.toLowerCase() === "alarm";

              return (
                <Card
                  key={lamp.id}
                  sx={{
                    p: 2,
                    backgroundColor: '#00122E',
                    color: '#ff9800',
                    width: '100%',
                    borderRadius: '20px',
                    border: '1px solid rgba(255,255,255,0.2)',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      gap: 4,
                      flexWrap: { xs: 'wrap', md: 'nowrap' }
                    }}
                  >
                    {/* GENERALNE INFORMACIJE GLAVNE */}
                    <Stack
                      spacing={0.5}
                      sx={{
                        flex: { xs: '1 1 100%', md: 1 },
                        alignItems: 'center' // ⬅️ centar kolone
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ color: '#90caf9', fontWeight: 600, textAlign: 'center' }}
                      >
                        Generalne informacije
                      </Typography>

                      {[
                        { label: 'Naziv lampe:', value: lamp.name },
                      ].map((item, index) => (
                        <Stack
                          key={`${lamp.id}-general-${index}`}
                          direction="row"
                          spacing={1}
                          sx={{
                            width: 'fit-content',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#ff9800',
                              fontSize: item.label === 'Naziv lampe:' ? '1.5rem' : '1rem',
                              fontWeight: item.label === 'Naziv lampe:' ? 700 : 400,
                              opacity: 0.9
                            }}
                          >
                            {item.label}
                          </Typography>

                          <Typography
                            sx={{
                              color: '#ff9800',
                              fontSize: item.label === 'Naziv lampe:' ? '1.5rem' : '1rem',
                              fontWeight: item.label === 'Naziv lampe:' ? 700 : 600
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Stack>
                      ))}
                      <br />
                      Režim rada:
                      {lamp.lightingmode ? (
                        <>
                          <Typography>Naziv: {lamp.lightingmode.name}</Typography>
                          <Typography>Opis: {lamp.lightingmode.description}</Typography>
                        </>
                      ) : lamp.zona?.lightingmode ? (
                        <>
                          <Typography sx={{ color: '#ff9800', fontStyle: 'italic' }}>
                            Nema režima na lampi, naslijeđuje iz zone:
                          </Typography>
                          <Typography>
                            {lamp.zona.lightingmode.name}
                          </Typography>
                        </>
                      ) : (
                        <Typography sx={{ color: '#ffb74d', fontStyle: 'italic' }}>
                          Režim rada nije definisan
                        </Typography>
                      )}
                      <br />
                      <Stack direction="row" spacing={1}>
                        <Button
                          sx={{
                            minWidth: 100,
                            backgroundColor: '#001B44',
                            color: '#ff9800',                // 🔥 tekst orange
                            border: '1px solid #ff9800',     // 🔥 border orange
                            '&:hover': {
                              backgroundColor: '#001B44',
                              border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                              color: '#ffa726'
                            }
                          }}
                          onClick={() => navigate("/lamp/update", { state: lamp })}
                        >
                          Uredi
                        </Button>

                        <Button
                          sx={{
                            minWidth: 100,
                            backgroundColor: '#001B44',
                            color: '#ff9800',                // 🔥 tekst orange
                            border: '1px solid #ff9800',     // 🔥 border orange
                            '&:hover': {
                              backgroundColor: '#001B44',
                              border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                              color: '#ffa726'
                            }
                          }}
                          onClick={() => setDeleteLamp(lamp)}
                        >
                          Obriši
                        </Button>
                      </Stack>
                    </Stack>

                    {/* GENERALNE INFORMACIJE */}
                    <Stack
                      spacing={0.5}
                      sx={{
                        flex: { xs: '1 1 100%', md: 1 },
                        alignItems: 'center' // ⬅️ centar kolone
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ color: '#90caf9', fontWeight: 600, textAlign: 'center' }}
                      >
                        Generalne informacije
                      </Typography>

                      {[
                        { label: 'Zona:', value: lamp.zona.name },
                        { label: 'Lokacija lampe:', value: lamp.installationAddress },
                        { label: 'Proizvođač:', value: lamp.manufacturer },
                        { label: 'Tip:', value: lamp.model },
                        { label: 'Serijski broj:', value: lamp.devEUNumber },
                        {
                          label: 'Status:',
                          value:
                            lamp.status === 'active'
                              ? 'Svijetli'
                              : lamp.status === 'inactive'
                                ? 'Ne svijetli'
                                : lamp.status // fallback ako je nešto drugo
                        }
                      ].map((item, index) => (
                        <Stack
                          key={`${lamp.id}-info-${index}`}
                          direction="row"
                          spacing={1}
                          sx={{
                            width: 'fit-content',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#ff9800',
                              fontSize: item.label === 'Naziv lampe:' ? '1.5rem' : '1rem',
                              fontWeight: item.label === 'Naziv lampe:' ? 700 : 400,
                              opacity: 0.9
                            }}
                          >
                            {item.label}
                          </Typography>

                          <Typography
                            sx={{
                              color:
                                item.label === 'Status:' && item.value?.toString().toLowerCase().includes('alarm')
                                  ? '#ff1744'   // crvena boja za alarm
                                  : '#ff9800',  // standardna bijela
                              fontSize: item.label === 'Naziv lampe:' ? '1.5rem' : '1rem',
                              fontWeight: item.label === 'Naziv lampe:' ? 700 : 600
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Stack>
                      ))}
                    </Stack>

                    {/* Telemetrijske informacije */}
                    <Stack
                      spacing={0.5}
                      sx={{
                        flex: { xs: '1 1 100%', md: 1 },
                        alignItems: 'center'
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ color: '#90caf9', fontWeight: 600, textAlign: 'center' }}
                      >
                        Status & Telemetrija
                      </Typography>
                      {hasData ? (
                        [
                          { label: 'SN:', value: data.devEUNumber || lamp.devEUNumber },
                          { label: 'Status:', value: data.channel?.onoff ? 'ON' : 'OFF' },
                          { label: 'Brightness:', value: (data.channel?.bri ?? 0) + ' %' },
                          { label: 'Voltage:', value: (data.channel?.elec?.voltage ?? 0) + ' V' },
                          { label: 'Current:', value: (data.channel?.elec?.current ?? 0) + ' mA' },
                          { label: 'Power:', value: (data.channel?.elec?.actps ?? 0) + ' W' },
                          { label: 'Runtime:', value: (data.runtime?.hours ?? 0) + ' h' },
                          { label: 'Lux:', value: (data.sensor?.lux ?? 0) }
                        ].map((item, index) => (
                          <Stack
                            key={`${lamp.id}-telemetry-${index}`}
                            direction="row"
                            spacing={1}
                            sx={{
                              width: 'fit-content',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            <Typography sx={{ color: '#ff9800', fontSize: '1rem', opacity: 0.9 }}>
                              {item.label}
                            </Typography>

                            <Typography sx={{ color: '#ff9800', fontSize: '1rem', fontWeight: 600 }}>
                              {item.value}
                            </Typography>
                          </Stack>
                        ))
                      ) : isAlarm ? (
                        <Typography
                          sx={{
                            color: '#ff5252',
                            fontStyle: 'italic',
                            textAlign: 'center'
                          }}
                        >
                          Lamp is under alarm, no data
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            color: '#90caf9',
                            fontStyle: 'italic',
                            opacity: 0.8,
                            textAlign: 'center'
                          }}
                        >
                          Waiting for live information…
                        </Typography>
                      )}
                    </Stack>


                    {/* UPRAVLJANJE */}
                    <Stack
                      spacing={1}
                      sx={{
                        flex: 1,
                        alignItems: 'center'
                      }}
                    >
                      {/* Naslov ostaje na vrhu i centriran horizontalno */}
                      <Typography
                        variant="subtitle2"
                        sx={{ color: '#90caf9', fontWeight: 600, textAlign: 'center', width: '100%' }}
                      >
                        Upravljanje
                      </Typography>

                      {/* Centrirani dio */}
                      <Stack
                        direction="column"       // vertikalni raspored
                        spacing={2}              // razmak između ikonice i kontrole
                        alignItems="center"      // horizontalno centrirano
                        justifyContent="center"  // vertikalno centrirano unutar roditelja
                      >
                        <Tooltip title={lamp.status === 'active' ? 'Lamp ON' : 'Lamp OFF'}>
                          <PowerSettingsNewIcon
                            sx={{
                              fontSize: 50,
                              color: lamp.status === 'active' ? '#4CAF50' : '#E57373',
                              cursor: 'default'
                            }}
                          />
                        </Tooltip>

                        <LampControl lamp={lamp} />
                      </Stack>


                    </Stack>
                  </Box>
                </Card>
              );
            })
          }

        </Stack>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredLamps.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          sx={{
            color: '#ff9800',

            '& .MuiTablePagination-selectLabel': {
              color: '#ff9800',
            },
            '& .MuiTablePagination-displayedRows': {
              color: '#ff9800',
            },
            '& .MuiSelect-icon': {
              color: '#ff9800',
            },
            '& .MuiInputBase-root': {
              color: '#ff9800',
            },
            '& .MuiIconButton-root': {
              color: '#ff9800',
            },
            '& .MuiIconButton-root.Mui-disabled': {
              color: 'rgba(255,255,255,0.3)',
            },
            '& .MuiTablePagination-selectLabel': {
              color: '#ff9800',
              marginTop: '12px'   // 👈 OVO PORAVNA
            },
            '& .MuiTablePagination-displayedRows': {
              color: '#ff9800',
              marginTop: '14px'
            },
          }}
        />
      </Container>
      <Dialog
        open={!!deleteLamp}
        onClose={() => setDeleteLamp(null)}
        PaperProps={{
          sx: {
            backgroundColor: '#0f172a',
            color: '#ff9800',
            borderRadius: 3
          }
        }}
      >
        <DialogTitle>Obriši lampu</DialogTitle>

        <DialogContent>
          <Typography>
            Da li si siguran da želiš obrisati lampu "{deleteLamp?.name}"?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setDeleteLamp(null)}
            sx={{ color: '#94a3b8' }}
          >
            Odustani
          </Button>

          <Button
            onClick={async () => {
              await axios.delete(`${SERVER_URL}/api/streetlamps/${deleteLamp.id}`);
              setStreetlamps(prev => prev.filter(l => l.id !== deleteLamp.id));
              setDeleteLamp(null);
            }}
            sx={{
              backgroundColor: '#dc2626',
              color: '#ff9800',
              '&:hover': { backgroundColor: '#b91c1c' }
            }}
          >
            Obriši
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
